import { render, staticRenderFns } from "./Pb1.vue?vue&type=template&id=6306a5c9&scoped=true"
import script from "./Pb1.vue?vue&type=script&lang=js"
export * from "./Pb1.vue?vue&type=script&lang=js"
import style0 from "./Pb1.vue?vue&type=style&index=0&id=6306a5c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306a5c9",
  null
  
)

export default component.exports